import { QueryEntity } from '@datorama/akita';
import { ViewsState } from 'core-app/core/state/views/views.store';

export class ViewsQuery extends QueryEntity<ViewsState> {
}
